import { forms, ActionTypes as types } from 'constants';
import { getFromIamApi, logError } from 'actions';

import { Auth } from 'utils';
import { initialize } from 'redux-form';
import { updateFetchAppError } from 'actions/setters/updateAppErrors';

const log = { component: 'getUser' };

export default (_getFromIamApi = getFromIamApi, _logError = logError) => (
  dispatch,
  getState,
) => {
  const { isLoaded } = getState().app.user;

  if (isLoaded) return Promise.resolve('isLoaded');

  dispatch({
    type: types.FETCH_USER,
  });

  const resourcePath = `/users/${Auth.getUserGuid()}`;

  return dispatch(_getFromIamApi(resourcePath))
    .then(([res, json]) => {
      if (res.ok) {
        dispatch({
          type: types.FETCH_USER_SUCCESS,
          payload: json.Result,
        });
        dispatch(initialize(forms.Name, json.Result));
        dispatch(initialize(forms.Email, json.Result));
        dispatch(initialize(forms.Phone, json.Result));
      } else if (json && json.Errors && json.Errors.length > 0) {
        const error = json.Errors[0].ErrorMessage;
        dispatch(updateFetchAppError());
        dispatch({ type: types.FETCH_USER_FAILURE });
        dispatch(
          _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, error }),
        );
      } else {
        dispatch(updateFetchAppError());
        dispatch({ type: types.FETCH_USER_FAILURE });
        dispatch(
          _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, res }),
        );
      }
    })
    .catch(error => {
      dispatch(updateFetchAppError());
      dispatch({ type: types.FETCH_USER_FAILURE });
      dispatch(
        _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, error }),
      );
    });
};
